export const CLOSE_PANEL = "close/panel";
export const OPEN_PANEL = "open/panel";
export const CHANGE_PANEL_TAB = "change/panel/tab";
export const UPDATE_BOOK_GRID_VIEW = "update/book/grid/view";
export const TOGGLE_MOBILE_HEADER_MENU = "toggle/mobile/header/menu";
export const CLOSE_MOBILE_HEADER_MENU = "close/mobile/header/menu";
